
<script>
import { defineComponent, inject } from 'vue'
import ParallaxImage from '@kit/components/ParallaxImage.vue'
import Config from '@kit/utils/Config'
import { mergeClassesTheme, mergeStylesTheme } from '@kit/utils/Formats'

const defaultConfig = new Config({
  //parallaxTheme
  //cover1Classes
  //cover1Style
  //cover2Classes
  //cover2Style
})


export default defineComponent({
  name: "ParallaxHeader",
  props: {
    //The image. Required
    "image": { require:true },

    //The aria label for the image. 
    "ariaImgLabel": { required: true },
    
    //the theme
    "theme": { required: false },

    //Everything after here are just the overrides to apply to the theme

    //the parallax theme
    "parallaxTheme": { required: false},

    //The cover-css for the spreader over the image. Handy for filters.
    //Optional.
    "cover1CSS": { required: false },

    //The classes to apply to the spreader of the image. Handy for filters
    //Optional. 
    "cover1Classes": { required: false },

    //The cover-css for the second spreader over the image. Handy for filters.
    //So we can have the cover1 be an opacity layer, and the second one can be
    //a gradient or something.
    //Optional. 
    "cover2CSS": { required: false },

    //The classes to apply to the second spreader of the image. Handy for filters
    //Optional. 
    "cover2Classes": { required: false },

    
  },
  setup(props) {

    const themer = inject("themer")

    const { getProp, setProp } = themer({ props, defaultConfig })

    return { mergeClassesTheme, mergeStylesTheme, getProp, setProp }
  },
  components: {
    ParallaxImage
  }
});
</script>

<template>

  <div aria-role="img" :aria-label="ariaImgLabel"> 
    <ParallaxImage :theme="getProp('parallaxTheme','theme')" :ariaImgLabel="ariaImgLabel || ''" :src="image"/>
    <div :class="mergeClassesTheme('sb-spread', getProp('cover1Classes'))" :style="getProp('cover1CSS')"></div>
    <div :class="mergeClassesTheme('sb-spread', getProp('cover2Classes'))" :style="getProp('cover2CSS')"></div>
  </div>

</template>